import Swiper, { Navigation, Lazy } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Lazy
    ]);
    // settings
    const settings = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 20,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 27
            }
        }
    };
    // init carousel
    new Swiper('.js-cart-carousel', settings);
};
